import {Component, signal} from '@angular/core';
import {NbSpinnerModule, NbTabsetModule} from "@nebular/theme";
import {SupportService} from "../../services/support.service";
import {VideoPlayerComponent} from "./video-player/video-player.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [
    TranslateModule,
    NbSpinnerModule,
    NbTabsetModule,
    VideoPlayerComponent
  ],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss'
})
export class SupportComponent {
  loading = signal<boolean>(false);
  tabChanged = signal<boolean>(false);
  videos = signal<any>({});

  constructor(private supportService: SupportService) {}

  ngOnInit() {
    this.loading.set(true);
    this.supportService.videos().subscribe((videos) => {
      this.videos.set(videos);
      this.loading.set(false);
    });
  }

  onTabChange() {
    this.tabChanged.set(true);
    setTimeout(() => this.tabChanged.set(false))
  }
}
